export default __webpack_public_path__ + "static/image-asset1-21470d379da98214482d1024adb8e86b.webp";